import { createFileRoute } from '@tanstack/react-router';
import { FeedbackSection } from '@/features/Lesson/FeedbackSection';
import { useTopicDetail } from '@/lib/hooks/useLms';

export const Route = createFileRoute('/_student/courses/$batchId/topics/$topicId/feedback')({
  component: FeedbackRoute,
});

function FeedbackRoute() {
  const { topicId } = Route.useParams();
  const { data: topic } = useTopicDetail(topicId);
  if (!topic) return null;
  return <FeedbackSection topicId={topicId} feedback={topic.my_feedback} />;
}
